export const features = [
  {
    icon: "ri-money-dollar-circle-line",
    title: "Save Money",
    description: "Access curated spreadsheets with the best price-to-quality ratio. Find hidden gems at unbeatable prices without compromising on style or quality.",
    imageSeq: "feat-save-money-img",
  },
  {
    icon: "ri-shield-check-line",
    title: "Trusted Links",
    description: "Every link in our superbuy spreadsheet is verified by experienced buyers. We only include sellers with proven track records and positive reviews.",
    imageSeq: "feat-trusted-links-img",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "Easy Shopping",
    description: "Navigate thousands of products effortlessly. Our organized superbuy spreadsheet makes finding exactly what you want quick and stress-free.",
    imageSeq: "feat-easy-shopping-img",
  },
];

export const testimonial = {
  rating: "4.9 / 5",
  text: "The superbuy spreadsheet completely changed how I shop. I used to spend hours searching for reliable links — now everything is organized in one place. Saved me hundreds of dollars and countless hours. Highly recommend for anyone getting started with superbuy.",
  author: "Marcus T.",
  info: "Verified Buyer · USA",
};

export const stats = {
  value: "50K+",
  label: "Products Curated",
  description: "Our team continuously updates the superbuy spreadsheet with the latest finds across all major categories. From streetwear essentials to luxury-inspired pieces, every product is handpicked and verified for quality.",
};

export const faqs = [
  {
    question: "What is a Superbuy Spreadsheet?",
    answer: "A Superbuy Spreadsheet is a curated collection of product links organized in a spreadsheet format, designed to help international buyers find and purchase items through the Superbuy agent platform. It contains verified product links across multiple categories including shoes, clothing, accessories, and more, making it easier to discover quality items at competitive prices.",
  },
  {
    question: "How do I use the Superbuy Spreadsheet?",
    answer: "Simply browse the categories on our website, click on any product category to access the corresponding spreadsheet section on Kaspreadsheet. Each link takes you directly to verified products. Copy the product link, paste it into Superbuy's search bar, and you can begin your purchase with full agent support including QC photos and consolidated shipping.",
  },
  {
    question: "Is Superbuy safe to use?",
    answer: "Yes, Superbuy is a legitimate shopping agent with years of experience serving international buyers. They offer buyer protection, quality inspection (QC) photos before shipping, secure payment processing, and a reliable refund system. Always use trusted spreadsheets like ours to ensure you're purchasing from verified sellers.",
  },
  {
    question: "How often is the spreadsheet updated?",
    answer: "Our superbuy spreadsheet is updated regularly to include the latest trending items, remove dead links, and add newly discovered products. We strive to maintain the most current and reliable collection of superbuy links available online.",
  },
  {
    question: "Do I need an account to use the spreadsheet?",
    answer: "No account is needed to browse our superbuy spreadsheet categories. Simply visit our website, explore the product categories, and click through to Kaspreadsheet to access the full spreadsheet. However, you will need a Superbuy account to make purchases.",
  },
  {
    question: "What categories are covered in the spreadsheet?",
    answer: "Our superbuy spreadsheet covers a wide range of categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and more. We're constantly expanding our coverage to include new categories based on buyer demand.",
  },
];

export const trustBadges = [
  { icon: "ri-shield-check-line", title: "Verified Links", desc: "Every link is manually checked and verified" },
  { icon: "ri-image-line", title: "QC Photos", desc: "Quality inspection before shipping" },
  { icon: "ri-refund-2-line", title: "Buyer Protection", desc: "Secure payments and refund support" },
  { icon: "ri-global-line", title: "Worldwide Shipping", desc: "Reliable delivery to over 200 countries" },
];

export const latestArticles = [
  {
    slug: "what-is-superbuy-spreadsheet",
    title: "What Is a Superbuy Spreadsheet? The Complete 2026 Guide",
    excerpt: "Learn everything about superbuy spreadsheets — what they are, how they work, why every international buyer needs one, and how to choose the best spreadsheet for your shopping needs.",
    imageSeq: "article-card-what-is",
  },
  {
    slug: "how-to-use-superbuy-spreadsheet",
    title: "How to Use Superbuy Spreadsheet in 2026: Step-by-Step",
    excerpt: "Master the superbuy spreadsheet workflow from start to finish. A beginner-friendly walkthrough covering account setup, link navigation, ordering, QC review, and shipping.",
    imageSeq: "article-card-how-to-use",
  },
  {
    slug: "best-superbuy-spreadsheet-sneakers",
    title: "Best Superbuy Spreadsheet for Sneakers: Top Picks",
    excerpt: "Discover the most reliable sneaker links in any superbuy spreadsheet. From budget trainers to rare collectible kicks, find the best footwear deals with verified sellers.",
    imageSeq: "article-card-sneakers",
  },
  {
    slug: "best-superbuy-spreadsheet-hoodies",
    title: "Best Superbuy Spreadsheet for Hoodies & Streetwear",
    excerpt: "Level up your streetwear game with the best hoodie finds from trusted superbuy spreadsheets. Explore oversized fits, designer-inspired pieces, and seasonal collections.",
    imageSeq: "article-card-hoodies",
  },
  {
    slug: "how-safe-is-superbuy",
    title: "How Safe Is Superbuy? Security & Buyer Protection",
    excerpt: "A detailed look at Superbuy's safety features including payment protection, QC inspection, privacy safeguards, refund policies, and tips to avoid common shopping pitfalls.",
    imageSeq: "article-card-safety",
  },
  {
    slug: "superbuy-vs-pandabuy",
    title: "Superbuy vs Pandabuy: Which Agent Is Better in 2026?",
    excerpt: "An honest side-by-side comparison of the two most popular shopping agents. Compare shipping costs, QC quality, customer support, fees, and spreadsheet compatibility.",
    imageSeq: "article-card-vs",
  },
  {
    slug: "best-budget-finds-superbuy",
    title: "Best Budget Finds on Superbuy: Hidden Gems Under $30",
    excerpt: "Uncover the most impressive budget-friendly products hiding in superbuy spreadsheets. Quality fashion, accessories, and lifestyle items that won't break the bank.",
    imageSeq: "article-card-budget",
  },
  {
    slug: "buy-from-yupoo-superbuy",
    title: "How to Buy From Yupoo Using Superbuy: Complete Guide",
    excerpt: "Navigate Yupoo albums like a pro and purchase through Superbuy with confidence. Learn how to decode album links, communicate with sellers, and avoid common Yupoo scams.",
    imageSeq: "article-card-yupoo",
  },
  {
    slug: "top-superbuy-finds",
    title: "Top 50 Superbuy Finds: Must-Have Products in 2026",
    excerpt: "The ultimate curated list of the most popular and highly-rated superbuy spreadsheet finds. From viral fashion pieces to everyday essentials loved by the community.",
    imageSeq: "article-card-top-finds",
  },
];